import { render, staticRenderFns } from "./OrderDetailChat.module.vue?vue&type=template&id=23489420&scoped=true&"
import script from "./OrderDetailChat.module.vue?vue&type=script&lang=js&"
export * from "./OrderDetailChat.module.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailChat.module.vue?vue&type=style&index=0&id=23489420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23489420",
  null
  
)

export default component.exports